export default __webpack_public_path__ + "static/media/AnimalsBlue_07.8369df30.png";